//import useAuth from '../../Hooks/useAuth';
//import { jwtDecode } from 'jwt-decode';
import {Link} from 'react-router-dom';

function AlumPageBanner({PT, img }) {
    //const { auth } = useAuth();
    //const authDecode = auth?.accessToken ? jwtDecode(auth.accessToken) : undefined;

    return (
        <section id="page-banner" className="pt-80 pb-50 bg_cover" data-overlay="8" style={{backgroundImage: `url(${img}page-banner-5.jpg)`}}>
            <div className="container">
                <div className="page-banner-cont">
                    <h2>Alumni Profiles</h2>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            { PT ? 
                                <>
                                    <li className="breadcrumb-item active"><Link to='/alum'>Alumni Profiles</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">{PT}</li>
                                </>
                                :
                                    <li className="breadcrumb-item active"  aria-current="page">Alumni Profiles</li>
                                }
                        </ol>
                    </nav>
                </div>  { /* <!-- page banner cont --> */}
            </div> { /* <!-- container --> */}
        </section>
    )
}

export default AlumPageBanner